// extracted by mini-css-extract-plugin
module.exports = {"label":"LabeledValue_label__3krFz","info":"LabeledValue_info__1e1tX"};